export default __webpack_public_path__ + "static/media/ao-salt.e2622ff0.svg";